module.exports = __webpack_public_path__ + "img/Pellets-Herstellung.e5da87c.png";